<div class="mainContent">


  <header style="height: 7vh; padding-left: 2%;">
    <label i18n="@@spmsUserReg" class="textColour">Test Bed</label>
  </header>
  
  

    <div class="testbed" style="height: 70vh; overflow-y: auto;overflow-x: hidden;  padding: 10px;">

    <div [hidden]="isVisible">

     <div class="row">
     <div class="col-lg-1"></div>

     <div class="col-lg-5">
    <div class="seperateDiv" style="overflow: hidden; flex-grow: 1;">
      <ag-grid-angular 
        class="ag-theme-balham table-width-fields tablestyles square scroolbar-dusty-grass square thin"  
        [columnDefs]="columnDefsForObjects"
        [animateRows]="true"
        [defaultColDef]="defaultColDef"
        [suppressPaginationPanel]="true"
        [rowMultiSelectWithClick]="false"
        [rowSelection]="rowSelection"
        [headerHeight]="35"
        [enableBrowserTooltips]="true"
        [floatingFiltersHeight]="45"
        [enableRangeSelection]="true"
        [debug]="true"
        (gridReady)="onGridReadyForObjects($event)"
        (cellClicked)="cellClickedObjects($event)"
        [class.clicked-gray-cell]="isClicked"
        [hidden]="false">
      </ag-grid-angular>
    </div>
  </div>

  <div class="col-lg-5">
    <div class="seperateDiv">
      <ag-grid-angular 
        class="ag-theme-balham table-width-fields tablestyles square scroolbar-dusty-grass square thin"
        [columnDefs]="columnDefsForSelectedFields"
        [animateRows]="true"
        [defaultColDef]="defaultColDef"
        [suppressPaginationPanel]="true"
        [rowMultiSelectWithClick]="false"
        [rowSelection]="rowSelectionForTablesFields"
        [rowHeight]="35"
        [headerHeight]="35"
        [enableBrowserTooltips]="true"
        [floatingFiltersHeight]="45"
        [enableRangeSelection]="true"
        [debug]="true"
        (gridReady)="onGridReadyForSelectedTableFields($event)"
        (cellClicked)="onRowSelectedToRemove($event)"
        [hidden]="false">
      </ag-grid-angular>
    </div>
  </div>

  <div class="col-lg-1"></div>
</div>

</div>



    <div class="col-lg-1" style="margin-top:30px"></div> 


    <div class="row" >
      <div class="col-lg-1"></div>

    
      <div class="col-lg-10">
      <mat-form-field appearance="outline" style="width: 100%;">
      <mat-label i18n="@@SecretName">Description</mat-label>
      <textarea matInput
            [(ngModel)]="description"
            #descRef="ngModel"
            name="description"
            rows="3"
            style="font-size: 16px; padding: 10px; width: 100%;"
            required>
  </textarea>
  <mat-error *ngIf="descRef.errors?.required && descRef.touched">
    Description field is required
  </mat-error>
</mat-form-field>

    </div>
    <div class="col-lg-1"></div>
    </div>

    

    <div class="row" >
      <div class="col-lg-1"></div>
      <div class="col-lg-8">
        <input 
        #fileInput 
        type="file" 
        multiple 
        (change)="onFileSelected($event)" 
        style="display: none;"/>
        



      <button type="button" 
      (click)="fileInput.click()"
      class="btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize" 
      [style.background-color]="backgroundColorButton" 
      style="padding: .3rem 1.6rem; font-size: .85rem; width: 150px; color: white;">
      upload files<em class="fas fa-upload" style="padding-left: 10px;" title="upload files" ></em>
      </button>
      </div>
    </div>
    
    <div class="col-lg-1" style="margin-top:30px"></div>  

    <div class="row">
      <div class="col-lg-1"></div>
      <div class="col-lg-10">
        <div *ngIf="selectedFileNames?.length">
          <ul style="list-style: none; padding: 0; display: grid; grid-template-columns: repeat(2, 1fr); grid-auto-rows: minmax(30px, auto); gap: 8px;">
            <li *ngFor="let name of pagedFileNames(); let i = index"
                [title]="name"
                style="display: flex; align-items: center; background: #f0f0f0; border-radius: 4px; padding: 4px 6px; overflow: hidden;">
    
              <span style="flex-grow: 1; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; font-size: 0.85rem;">
                {{ name }}
              </span>
    
              <em class="fas fa-times-circle"
                  (click)="removeFile(currentPage * pageSize + i)"
                  title="Remove this file"
                  style="color: red; cursor: pointer; margin-left: 6px; font-size: 14px;">
              </em>
            </li>
          </ul>
    
         <div style="text-align: center; margin-top: 10px; font-size: 1.2rem;">
  <div class="card pagination paginationButtons btn-rounded">
    <ul style="display: flex; justify-content: center; align-items: center; list-style: none; margin: 0; padding: 0; gap: 12px;">
      <li class="paginationliicon">
        <em class="fas fa-angle-left waves-effect waves-light" (click)="previousPage()" style="cursor: pointer;"></em>
      </li>
      <li style="font-weight: 500;">
        {{ currentPage + 1 }}/{{ RuntotalPages }}
      </li>
      <li class="paginationliicon">
        <em class="fas fa-angle-right waves-effect waves-light" (click)="nextPage()" style="cursor: pointer;"></em>
      </li>
    </ul>
  </div>
</div>

        </div>
      </div>
    </div>
  </div>
   
    
  
  <div style="height:5vh">
    <div class="row" style= "position:sticky;left:0;bottom:0;width:100%;">

      <div class="col-lg text-center">
  
        <div style="text-align: end;">
          <button i18n="@@TargetClear" type="button" (click)="updateData()"
            class="btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize"
            [style.background-color]="backgroundColorButton"
            style="padding: .3rem 1.6rem;font-size: .85rem;width:95px;color: white;">
            {{ Buttonname }}
          </button>
  
          <button i18n="@@TargetCancel" type="button" (click)="close()"
            class="btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize"
            [style.background-color]="backgroundColorButton"
            style="padding: .3rem 1.6rem;font-size: .85rem;width:95px;color: white;">
            Cancel
          </button>
        </div>
      </div>
    </div>
  </div>
    

  
</div>
  
  
  

